import { cn } from '@/shared/lib/utils'
import { Avatar, AvatarFallback, AvatarImage } from '@/shared/ui/avatar'

type UserChipProps = {
  name: string | null | undefined
  avatar?: string | null
  className?: string
}

/**
 * Chip avatar + nombre para las personas de los paneles de detalle (asesor,
 * creado por, actualizado por…). Familia compartida, antes vivía en clients.
 */
export function UserChip({ name, avatar, className }: UserChipProps) {
  if (!name) return <>—</>
  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <Avatar seed={name} className="h-5 w-5">
        {avatar ? <AvatarImage src={avatar} alt={name} /> : null}
        <AvatarFallback className="text-[10px]">{name.charAt(0)}</AvatarFallback>
      </Avatar>
      <span className="truncate">{name}</span>
    </span>
  )
}
